import { initMixpanelEvents } from "jiffy-analytics";
import { initUploadButton } from "./ui";

import "./jiffytransfers-landing-v2.scss";
import "./sections/hero-section/hero-section";
import "./sections/value-props-section/value-props-section";
import "./sections/printer-preference-success-message/printer-preference-success-message";
import "./sections/perfect-projects-steps-section/perfect-projects-steps-section";
import initPopularDtfTransfers from "./sections/popular-dtf-transfers-section/popular-dtf-transfers-section";
import "./sections/why-jiffy-section/why-jiffy-section";
import "./sections/discover-section/discover-section";
import "./sections/made-with-jiffy-section/made-with-jiffy-section";
import "./sections/customer-feedback-section/customer-feedback-section";
import "./sections/calculator-section/calculator-section";
import "./sections/find-the-canvas-section/find-the-canvas-section";
import "./sections/transfers-styles-section/transfers-styles-section";
import "./sections/pressing-dtf-section/pressing-dtf-section";
import "./sections/customer-reviews-section/customer-reviews-section";
import "./sections/experience-the-difference-section/experience-the-difference-section";
import "./sections/faq-section/faq-section";
import "./sections/tips-and-tricks-section/tips-and-tricks";
import "./sections/footer-section/footer-section";

document.addEventListener("DOMContentLoaded", () => {
  initMixpanelEvents(".jiffytransfers-landing-v2");
  initUploadButton();
  // Initialize upload functionality for popular DTF transfers section
  initPopularDtfTransfers();
});
